var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays the electrical damage type selection using image radio buttons and applies insurer-configured choices.
 * touches: declaration, damage, electricalDamage, contract, selfCareSettings
 * invariants: The selected electrical damage type is synchronized with the electricalDamage store; available choices depend on insurer configuration and the contract owner's/co-owner's status.
 * inputs: changeKey, electricalDamage change state, selectedContract, selfCareSettings, electricalDamageTypesImages configuration
 * outputs: updates the damage type through updateType; resets the type field validation state through untouchField; emits the update event after changes.
 * see: @declaration/store/electricalDamage, @declaration/store/createDamageStore, @declaration/constants/electricalDamageConstants, @shared/types/api/electricalDamage
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiRadio, UiCard } from '@claims-ia/design-system';
import SecondaryButton from '@declaration/components/UI/SecondaryButton.vue';
import { ELECTRICAL_DAMAGE_TYPES_IMAGE_CHOICES, ElectricalDamageTypesDefault, } from '@declaration/constants/electricalDamageConstants';
const electricalDamage = namespace('electricalDamage');
const contract = namespace('contract');
const settings = namespace('settings');
let ElectricalDamageTypeSection = class ElectricalDamageTypeSection extends Vue {
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    get value() {
        var _a;
        const { data } = this.changeGetter(this.changeKey);
        return (_a = data.type) !== null && _a !== void 0 ? _a : null;
    }
    set value(type) {
        this.updateType({ type, changeKey: this.changeKey });
        this.untouchField({ fieldName: 'type', changeKey: this.changeKey }); // Untouch to prevent validation error on next section
        this.$emit('update');
    }
    get isOwner() {
        if (!this.contract)
            return false;
        return this.contract.housingCapacity.owner || this.contract.housingCapacity.coOwner;
    }
    get choices() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let customValues = null;
        if (((_d = (_c = (_b = (_a = this.selfCareSettings) === null || _a === void 0 ? void 0 : _a.declaration) === null || _b === void 0 ? void 0 : _b.pages) === null || _c === void 0 ? void 0 : _c.electricalRealEstateDamages) === null || _d === void 0 ? void 0 : _d.electricalDamageTypesImages) &&
            this.isOwner) {
            const insurerCustomValues = (_h = (_g = (_f = (_e = this.selfCareSettings) === null || _e === void 0 ? void 0 : _e.declaration) === null || _f === void 0 ? void 0 : _f.pages) === null || _g === void 0 ? void 0 : _g.electricalRealEstateDamages) === null || _h === void 0 ? void 0 : _h.electricalDamageTypesImages;
            customValues = ELECTRICAL_DAMAGE_TYPES_IMAGE_CHOICES.filter((item) => insurerCustomValues.includes(item.value));
        }
        else {
            customValues = ELECTRICAL_DAMAGE_TYPES_IMAGE_CHOICES.filter((item) => ElectricalDamageTypesDefault.includes(item.value));
        }
        return (customValues !== null && customValues !== void 0 ? customValues : ELECTRICAL_DAMAGE_TYPES_IMAGE_CHOICES).map((choice) => ({
            value: choice.value,
            label: this.$tc(choice.tradKey),
            imageSrc: choice.image,
        }));
    }
    get shouldShowNotListedButton() {
        return !this.choices.some((item) => item.value === 'autre');
    }
};
__decorate([
    electricalDamage.Getter('change')
], ElectricalDamageTypeSection.prototype, "changeGetter", void 0);
__decorate([
    electricalDamage.Action('updateType')
], ElectricalDamageTypeSection.prototype, "updateType", void 0);
__decorate([
    electricalDamage.Mutation('UNTOUCH_FIELD')
], ElectricalDamageTypeSection.prototype, "untouchField", void 0);
__decorate([
    contract.State('selectedContract')
], ElectricalDamageTypeSection.prototype, "contract", void 0);
__decorate([
    settings.Getter('setting')
], ElectricalDamageTypeSection.prototype, "setting", void 0);
ElectricalDamageTypeSection = __decorate([
    Component({
        components: { SecondaryButton, UiButton, UiRadio, UiCard },
        props: {
            changeKey: { type: [Number, String], default: null },
            errors: { type: Array, default: () => [] },
        },
    })
], ElectricalDamageTypeSection);
export default ElectricalDamageTypeSection;
